/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 * The vx-image-gallery displays two carousels - the main carousel and the thumbnail carousel.
 * When the main carousel moves, the active thumbnail will change. Also, thumbnails are
 * clickable to navigate the main carousel.
 * This component is based on the Splide-library (https://splidejs.com).
 */
// eslint-disable-next-line require-jsdoc
export class VxContentSlide {
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '46f856d1caa67e31b852436ff3cac4862714d90f', class: "splide__slide" }, h("slot", { key: '94ea4a7e3a684316fbe5093959f50aefd01d5dea' })));
    }
    static get is() { return "vx-content-slide"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-content-slide.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-content-slide.css"]
        };
    }
}
//# sourceMappingURL=vx-content-slide.js.map
